import React from 'react'

const EditBooking = () => {
  return (
    <div>edit-booking</div>
  )
}

export default EditBooking